if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"nwia","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 540 != chunkId},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}